import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

/**
 * Exports JSON data to Excel
 * @param {Array} data - Array of objects to export
 * @param {Object} columnMapping - Object mapping: { "Excel Column Name": "keyInData" }
 * @param {string} fileName - Name of the exported Excel file
 */
export const exportToExcel = (data, columnMapping, fileName = "Export.xlsx") => {
  if (!data || data.length === 0) {
    alert("No data to export");
    return;
  }

  // Map data to desired columns
  const formattedData = data.map((item, index) => {
    const row = {};
    Object.keys(columnMapping).forEach((colName) => {
      const key = columnMapping[colName];
      if (typeof key === "function") {
        row[colName] = key(item, index); // allow custom formatting
      } else {
        row[colName] = item[key];
      }
    });
    return row;
  });

  // Create worksheet and workbook
  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // Generate Excel file
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const file = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(file, fileName);
};
